"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function(mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const VmwareNodeValidation_1 = require("../validations/VmwareNodeValidation");
const cloudProvider_1 = __importDefault(require("../types/cloudProvider"));
const utils_1 = require("../helper/utils");
class VmwareNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.VMWARE };
    if (props.type !== types_1.NODE_TYPES.VMWARE)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    if (!nodeData)
      nodeData = {
        resource: ""
      };
    return nodeData;
  }
  serialize(uiData) {
    return uiData;
  }
  validate() {
    return new VmwareNodeValidation_1.VmwareNodeValidation().validate(this);
  }
  async getAvailableResources() {
    let availableResources = [];
    const nodeData = this.getNodeData();
    if (nodeData) {
      let resource = nodeData.resource;
      let sgcData = await utils_1.getSgcData(
        this.getDataResolver(),
        `${cloudProvider_1.default.VMWARE}/resources.json`
      );
      let rec = sgcData.find(u => u.service === resource);
      let label = rec ? rec.displayService : "";
      availableResources.push({
        nodeRef: this,
        selectedResourceId: this.id,
        path: "",
        label: [this.getNodeName(), label].join("."),
        context: {
          outputPath: ""
        }
      });
    }
    return availableResources;
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
  getCloudProvider() {
    return cloudProvider_1.default.VMWARE;
  }
}
exports.VmwareNode = VmwareNode;
//# sourceMappingURL=VmwareNode.js.map
